import React, { useEffect } from "react";
import Init from "../3D/SceneManager";
import Landing from "./Landing";
import Loader from "./Loader";
import VideoBG from "./VideoBg";
import { AppWrapper, LandingWrapper } from "../styles/components/Global/Global";

const App = () => {
  useEffect(() => {
    Init();
  });
  return (
    <AppWrapper id="app-wrapper">
      <Loader />
      <Landing />
      <canvas id="app" />
    </AppWrapper>
  );
};

export default App;
